import { useState } from "react";
import { List, X } from "@phosphor-icons/react";
import LogoMark from "@/components/LogoMark";
import { scrollToSection } from "@/components/Reveal";

const LINKS = [
  { label: "Services", href: "#services", testId: "nav-services-link" },
  { label: "Why Georgia", href: "#georgia", testId: "nav-georgia-link" },
  { label: "Partners", href: "#partners", testId: "nav-partners-link" },
  { label: "Contact", href: "#contact", testId: "nav-contact-link" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const go = (e, href) => {
    setOpen(false);
    scrollToSection(e, href);
  };

  return (
    <header
      data-testid="navbar"
      className="fixed inset-x-0 top-0 z-50 border-b border-[#E2E8F0] bg-white/85 shadow-sm backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-[1440px] items-center justify-between px-6 py-4 md:px-12">
        <a
          href="#top"
          data-testid="nav-logo-link"
          onClick={(e) => go(e, "#top")}
          className="flex items-center gap-3"
        >
          <LogoMark size={30} />
          <span className="font-display text-lg font-medium tracking-[0.18em] text-[#071526]">
            WOFERS <span className="text-[#184167]">GLOBAL</span>
          </span>
        </a>

        <nav className="hidden items-center gap-9 lg:flex" data-testid="nav-desktop-menu">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testId}
              onClick={(e) => go(e, l.href)}
              className="text-xs font-medium uppercase tracking-[0.2em] text-[#5C6B7C] transition-colors duration-300 hover:text-[#184167]"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="nav-cta-button"
            onClick={(e) => go(e, "#contact")}
            className="border border-[#184167]/60 px-6 py-2.5 text-xs font-semibold uppercase tracking-[0.2em] text-[#184167] transition-colors duration-300 hover:bg-[#184167] hover:text-white"
          >
            Become a Partner
          </a>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="text-[#071526] lg:hidden"
          aria-label="Toggle menu"
        >
          {open ? <X size={26} weight="light" /> : <List size={26} weight="light" />}
        </button>
      </div>

      {open && (
        <nav
          data-testid="nav-mobile-menu"
          className="border-t border-[#E2E8F0] bg-white/95 px-6 pb-8 pt-4 backdrop-blur-xl lg:hidden"
        >
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`${l.testId}-mobile`}
              onClick={(e) => go(e, l.href)}
              className="block border-b border-[#E2E8F0] py-4 font-display text-2xl font-light text-[#071526] transition-colors hover:text-[#184167]"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="nav-cta-button-mobile"
            onClick={(e) => go(e, "#contact")}
            className="mt-6 block border border-[#184167]/60 px-6 py-3.5 text-center text-xs font-semibold uppercase tracking-[0.2em] text-[#184167]"
          >
            Become a Partner
          </a>
        </nav>
      )}
    </header>
  );
}
